import angular from 'angular';
import uiRouter from 'angular-ui-router';
import vehicleAppraisalComponent from './vehicleAppraisal.component';
import BasicDetails from './basicDetails/basicDetails';
import Bodywork from './bodywork/bodywork';
import ReconCost from './reconCost/reconCost';
import AppraisalConclude from './appraisalConclude/appraisalConclude';

let vehicleAppraisalModule = angular.module('vehicleAppraisal', [
  uiRouter,
  BasicDetails,
  ReconCost,
  Bodywork,
  AppraisalConclude
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider
    .state('vehicleTradeIn', {
      url: '/vehicle/tradeIn',
      component: 'vehicleAppraisal',
      params: {
        origin: { },
        contactId: null,
        enquiryId: null,
        settlement: null     
      }
    });

    $stateProvider
      .state('editAppraisal', {
        url: '/vehicle/editAppraisal/:vehicleId',
        component: 'vehicleAppraisal',
        params: {
          origin: { },
          enquiryId: null,
          settlement: null
        }
      });
})

.component('vehicleAppraisal', vehicleAppraisalComponent)

.name;

export default vehicleAppraisalModule;



// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleAppraisal/vehicleAppraisal.js